<template>
  <div class="container clearfix">
    <div
      class="users form login-form login-field"
      style="max-width: 400px; margin: 0 auto; height"
    >
      <p style="color: red">{{ errorMessage }}</p>
      <fieldset>
        <legend>ユーザーログイン</legend>
        <h5>SNSでのログインはこちら</h5>
        <button
          @click="auth('facebook')"
          class="btn btn-social btn-facebook"
          style="
            background-color: #3b5998;
            color: white;
            margin-bottom: 10px;
            width: 100%;
          "
        >
          <i class="fab fa-facebook" style="margin-right: 10px"></i
          >Facebookでログインする
        </button>
        <button
          @click="auth('google')"
          class="btn bg-danger btn-google"
          style="color: white; width: 100%"
        >
          <i class="fab fa-google" style="margin-right: 10px"></i
          >Googleでログインする
        </button>
        <hr />

        <h5>DEVEREACH アカウントログインはこちら</h5>
        <div class="input email required" style="margin-bottom: 10px">
          <input
            type="email"
            name="email"
            class="form-control"
            required="required"
            placeholder="メールアドレス"
            id="email"
            v-model="profile.email"
          />
        </div>
        <div class="input password required">
          <input
            type="password"
            name="password"
            class="form-control"
            required="required"
            placeholder="パスワード"
            id="password"
            v-model="profile.password"
          />
        </div>
        <div style="text-align: center; margin-top: 10px">
          <a @click="register">ユーザー登録</a> | ログインできない方は
          <a @click="requestResetPassword">こちら</a>
        </div>
      </fieldset>
      <div style="text-align: center; margin: 10px">
        <router-link class="btn btn-default" :to="{ name: 'top' }"
          >ホームへ戻る</router-link
        >
        <button class="btn btn-primary" @click="login">ログイン</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      profile: {
        email: "",
        password: "",
      },
      profileFromOauth: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        picture: "",
        accessToken: "",
        provider: "",
      },
      isOpen: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      apiStatus: (state) =>
        state.auth.apiStatus !== null && state.auth.apiStatus,
      errorMessage: (state) => state.auth.errorMessage,
    }),
  },
  mounted() {
    this.$store.commit("auth/setErrorMessage", null);
  },
  methods: {
    async auth(network) {
      // TODO: loadingのON/OFFが散らばっているのでまとめれる場合はまとめる
      try {
        this.loading = true;
        const hello = this.hello;
        const self = this;
        //  (1) Oauthにリダイレクトして、ユーザーから情報提供の許可を取得（アクセストークンを取得）
        hello(network)
          .login({ scope: "email" })
          .then(() => {
            const authRes = hello(network).getAuthResponse();
            this.profileFromOauth.accessToken = authRes.access_token;
            this.profileFromOauth.provider = network;

            //（２）アクセストークンからユーザーの詳細情報を取得
            hello(network)
              .api("me")
              .then((response) => {
                self.profileFromOauth.id = response.id;
                self.profileFromOauth.name = response.name;
                self.profileFromOauth.email = response.email;
                self.profileFromOauth.firstName = response.first_name;
                self.profileFromOauth.lastName = response.last_name;
                self.profileFromOauth.picture = response.picture;

                // （４）バックエンドにプロフィール情報を渡して、ログイン or 新規登録する（Authトークンを取得）
                this.loginByOauth();
              });
          });
      } finally {
        this.loading = false;
      }
    },
    // Oauth認証
    async loginByOauth() {
      try {
        this.loading = true;
        await this.$store.dispatch("auth/loginByOauth", this.profileFromOauth);
      } finally {
        this.loading = false;
      }

      this.loginHandler();
    },
    // Email認証
    async login() {
      try {
        this.loading = true;
        await this.$store.dispatch("auth/loginByEmail", this.profile);
      } finally {
        this.loading = false;
      }

      this.loginHandler();
    },
    // 認証後ステータスに応じてルーティングする
    loginHandler() {
      if (this.apiStatus) {
        this.$router.push({ name: "pay-select" });
        return;
      }
    },
    register() {
      this.$router.push({ name: "register" });
    },
    requestResetPassword() {
      this.$router.push({ name: "requestResetPassword" });
    },
  },
};
</script>

<style scoped>
.login-form {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 450px) {
  .login-field {
    width: 80%;
  }
}
</style>
